import ProfileBanner from './profile-banner';

export default ProfileBanner;
